import { inject, Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ToolsModalComponent } from 'src/app/features/tooling/components/tools-modal/tools-modal.component';
import { ToolService } from 'src/app/features/tooling/services/tool.service';
import { ImageModalComponent } from 'src/app/shared/components/image-modal/image-modal.component';
import { LoadingOverlayService } from 'src/app/shared/services/spinner-overlay.service';
import { Location } from '@angular/common';
import { ConfirmationDialogComponent, ConfirmationDialogData } from 'src/app/shared/components/confirmation-dialog/confirmation-dialog.component';
import { Observable } from 'rxjs';

@Injectable()
export class DialogHelper {
    constructor(
        private dialog: MatDialog,
    ) {}
    
    private loadingOverlayService = inject(LoadingOverlayService);
    private toolService = inject(ToolService);
    private location = inject(Location);
    
    openToolModalDialog(toolId: number): void {
        this.loadingOverlayService.show();
        this.toolService.getToolById(toolId).subscribe((tool: any) => {
            let width = '1000px';
            let height = '65vh';

            if (tool == null) {
                width = '350px';
                height = 'auto';
            }
            
            this.dialog.open(ToolsModalComponent, {
                width: `${width}`,
                height: `${height}`,
                maxHeight: '600px',
                data: tool
            });

            if(tool != null) this.location.go(`/tooling?Id=${toolId}`);
            this.loadingOverlayService.hide();
        });
    }

    openImageModalDialog(imageUrls?: string[], currentIndex?: number): void {
        this.dialog.open(ImageModalComponent, {
            data: { imageUrls, currentIndex: currentIndex ?? 0 },
            panelClass: 'transparent-dialog',
            backdropClass: 'dark-backdrop',
            restoreFocus: false,
            autoFocus: false
        });
    }

    openConfirmationDialog(data: ConfirmationDialogData): Observable<boolean> {
        const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
            width: '400px',
            restoreFocus: false,
            autoFocus: false,
            data
        });
        
        return dialogRef.afterClosed();
    }
}